import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export const useStyles = makeStyles(({ spacing }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    height: '100%',
  },
  wrapper: {
    display: 'flex',
    margin: spacing(20, 23, 16, 34),
    height: 'calc(100vh - 160px)',
    minHeight: 'calc(100vh - 160px)',
  },
}))

export const COLUMN_WRAPPER_STYLE = {
  maxWidth: 'max-content',
  width: 'max-content',
  overflow: 'hidden',
  height: 'calc(100vh - 180px)',
  minHeight: 'calc(100vh - 180px)',
}

export const COLUMN_STYLE = {
  height: 'calc(100vh - 180px)',
  minHeight: 'calc(100vh - 180px)',
  background: Theme.Colors.Primary.Lightest,
  paddingBottom: '16px',
  marginBottom: '16px',
  paddingRight: 0,
}

export const MINIMIZED_COLUMN_STYLE = {
  height: 'calc(100vh - 180px)',
  minHeight: 'calc(100vh - 180px)',
  background: Theme.Colors.Primary.Lightest,
  paddingBottom: '16px',
  marginBottom: '16px',
  width: '40px',
  minWidth: '40px',
  maxWidth: '40px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '8px 4px',
}

export const MINIMIZED_COLUMN_WRAPPER_STYLE = {
  maxWidth: '40px',
  width: '40px',
  minWidth: '40px',
  overflow: 'hidden',
}

export const ROOT_STYLE = {
  overflowX: 'scroll',
  overflowY: 'hidden',
}

/* Highlight helpers applied during card drag interactions */
export const COLUMN_HIGHLIGHT_DIM_STYLE = {
  opacity: 0.5,
  transition: 'opacity 150ms ease-in-out',
}

export const COLUMN_HIGHLIGHT_ALLOWED_STYLE = {
  border: `2px solid ${Theme.Colors.Primary.Base}`,
  boxSizing: 'border-box',
  opacity: 1,
}
